import styled, { css } from "styled-components";

interface IsButton {
  children: any;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isActivated?: boolean;
}

export default function StateButton({
  children,
  onClick,
  isActivated,
}: IsButton) {
  return (
    <ButtonWrap onClick={onClick} isActivated={isActivated}>
      {children}
    </ButtonWrap>
  );
}

interface IsButtonWrap {
  isActivated?: boolean;
}

const ButtonWrap = styled.button<IsButtonWrap>`
  width: fit-content;
  height: 36px;
  background-color: white;
  color: #314af3;
  border: 1px solid #314af3;
  padding: 0px 24px;
  font-size: 14px;
  transition: all 0.16s ease-out;
  ${({ isActivated }) =>
    isActivated &&
    css`
      background-color: #314af3;
      color: white;
      border: none;
      cursor: pointer;
    `}
`;
